/**
 * Accor Plus API calls
 * Date Created: 01/07/2022
 */

import Helper from "../common/helper";
import qs from "qs";
import { getEnvironmentConfiguration } from "../common/environments.js";

const environment_configuration = getEnvironmentConfiguration();

const headers = new Headers({
  "Content-Type": "application/json",
});

const headers2 = new Headers({
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
});

// let headersApiKey =  new Headers({
//     'Access-Control-Allow-Origin': '*',
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${apiKey}`,
// })

const ApiService = {
  userdata: async function () {
    let json, token;
    if (document.cookie) {
      json = document.cookie.split("; ").reduce((prev, current) => {
        const [name, ...value] = current.split("=");
        prev[name] = value.join("=");
        return prev;
      }, {});

      /*if(json.token) {
                token = JSON.parse(unescape(json.token));
            }*/
      // console.log(decodeURI(json.allUserData))
      if (json.allUserData) {
        const userData = decodeURIComponent(json.allUserData)
          .replace(/%3A/g, ":")
          .replace(/%2C/g, ",")
          .replace(/%40/g, "@")
          .replace(/%2F/g, "/");

        if (userData) {
          try {
            const token = JSON.parse(userData);
            return token; // Return token if parsing is successful
          } catch (error) {
            console.error("Error parsing allUserData:", error);
          }
        }
      }

      if (json.accorUserData) {
        token = JSON.parse(unescape(json.accorUserData));
        return token;
      }
    }

    //no user data detected
    return false;

    /*return fetch(environment_configuration.payments_base_url + environment_configuration.payments_api_version + "/member/me", {
            method: 'GET',
            "headers": new Headers({
                // 'Authorization': 'Bearer ' + "eyJhbGciOiJSUzI1NiIsImtpZCI6IkFaRXhjZHp6dnFxUVRBRFZFMTI4U1pOQlFLU0R4aGR6QVFmeHhoZGNkdnV6MTIzc2ZjIiwicGkuYXRtIjoiM2F3ZiJ9.eyJzY3AiOiJBUElXRUIuVVNFUi5XUklURV9QUk9GSUxFIG9wZW5pZCBBUElXRUIuVVNFUi5SRUFEX1BST0ZJTEUgQVBJV0VCLlVTRVIuV0FMTEVUIiwiY2xpZW50SWQiOiJjb20uYWNjb3JwbHVzIiwiY29udGFjdElkIjoiMTAwMDAxMDgzODcyMzcwIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwicG1pZCI6IjA1MDg4MzlBIiwiZXhwIjoxNjYyMzU0NDIyfQ.NfvT3zchlSU_3_01fJJ6Ri2XoMMnZNN4nZ5NwuJQ06OuoEZtGKSnAXWnxXUVcEfZvZJOFMw6ejlu2x6kVgRSSSfPXA58BneXSwxg47VG1bHPq20342no1XRhz7IlfQwa_sZd9a4AQpNfPTNUAXElL87TYqVbZpmJ5fpC4tBAJOlNXOpwwnGaq-7s8JzJ_FBySeljddD--Ebe27rqqw9CEZkfysHAEbhHgVY8-EFdVVbOMCCBLTIkVzM1gyoOSXKUH9L0rkvrx8rq261QVR488MgFnwJYoOM9lTKr0PqKTx5ra3MHrOHXuXCCcQiPmeSYoclljB9PfbxHLwB609ibZg",
                //'Authorization': 'Bearer ' + "eyJhbGciOiJSUzI1NiIsImtpZCI6IkFaRXhjZHp6dnFxUVRBRFZFMTI4U1pOQlFLU0R4aGR6QVFmeHhoZGNkdnV6MTIzc2ZjIiwicGkuYXRtIjoiM2F3ZiJ9.eyJzY3AiOiJBUElXRUIuVVNFUi5XUklURV9QUk9GSUxFIG9wZW5pZCBBUElXRUIuVVNFUi5SRUFEX1BST0ZJTEUgQVBJV0VCLlVTRVIuV0FMTEVUIiwiY2xpZW50SWQiOiJjb20uYWNjb3JwbHVzIiwiY29udGFjdElkIjoiMTAwMDAxMDgzODcyMzcwIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwicG1pZCI6IjA1MDg4MzlBIiwiZXhwIjoxNjY2MzMyODUyfQ.K6NPnw7Y7hbrYHMBLuHLAZmUsg2xdT_z3TySHafgk-99rjfVVQff0f9z6SJ0nh4DfQ0P1qvE2CPNVhfQAC8aYZOiCH2nmOkcHMVjOvgUGgFo2H5XBE2rgrnsmozS8812VyJzw2ZT2fXIe6lltx9BNhNWMNMntRtVpd3XKgxQ0AltpwJciLNK_Awia9EmpQYQFv4O4XnKN4DC39TlqUscxL8297veCorUCv_JYM9-PN2bZi_Yt9apzCeZwi-BBEHdQqG_S31cJ8AtJwW1tJluvwnsZXUum9Xn72WMVmUwYY-CWdWBAwLKnE_3xixzT0Q7gBmy23T-Dgy6IvlI14v01w",
                'Authorization': 'Bearer ' + token.access_token,
                'Content-Type': 'application/json'
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});*/
  },

  getLanguages: () =>
    Promise.resolve(
      new Response(JSON.stringify(environment_configuration.translations), {
        status: 200,
      }),
    ),

  getBenefits: () =>
    Promise.resolve(
      new Response(JSON.stringify(environment_configuration.benefits), {
        status: 200,
      }),
    ),

  getLocationData: function (params) {
    let data = params ? Helper.jsonToUrlParameters(params) : "";
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/functions/locationdata" +
        data,
      {
        method: "GET",
        headers2,
      },
    );
  },

  getProducts: function (bc, subsidiary, language, pricelevel, ui_channel) {
    let date = new Date();
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let dateToday =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;

    let data = {
      subsidiary: subsidiary,
      language: language || "en-au",
      date: dateToday,
      ui_channel: ui_channel,
    };

    if (pricelevel) {
      data["pricelevel"] = pricelevel;
    } else {
      data["bc"] = bc;
    }

    if (ui_channel) {
      data["pricelevel"] = null;
      data["bc"] = null;
    }

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/products/membership",
      {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      },
    );

    // Sandbox BC structure for PWP check has been changed -> using the prod Membership to check the products with the old PWP structure
    // return fetch('https://payments-api.accorplus.com/' + environment_configuration.payments_api_version + "/products/membership", {
    //     method:"POST",
    //     headers,
    //     body:JSON.stringify(data)
    // });
  },

  createTransaction: async function (params) {
    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions",
      {
        method: "POST",
        headers,
        body: data,
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  createOrderItems: async function (id, params) {
    let date = new Date();
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let dateToday =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;

    params["date"] = dateToday;

    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        `/transactions/${id}/orderitems`,
      {
        method: "POST",
        headers,
        body: data,
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  asiaPayDirectLink: async function (params) {
    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/asiapay/directlink",
      {
        method: "POST",
        headers,
        body: data,
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  asiaPayDirectClient: function (params) {
    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/asiapay/directclient",
      {
        method: "POST",
        headers,
        body: data,
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  limePayCreateOrder: function (params) {
    let data = JSON.stringify(params);

    // return fetch(environment_configuration.payments_base_url + environment_configuration.payments_api_version + "/transactions/merchant/limepay/order", {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/limepay-v3/order",
      {
        method: "POST",
        headers,
        body: data,
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  limePayCreatePayment: function (params) {
    let data = JSON.stringify(params);

    // return fetch(environment_configuration.payments_base_url + environment_configuration.payments_api_version + "/transactions/merchant/limepay/payment", {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/limepay-v3/payment",
      {
        method: "POST",
        headers,
        body: data,
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  stripeCreateSubscription: function (params) {
    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/stripe/createsubscription",
      {
        method: "POST",
        headers,
        body: data,
      },
    );
  },

  stripeCreatePaymentIntent: function (params) {
    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/stripe/createpaymentintent",
      {
        method: "POST",
        headers,
        body: data,
      },
    );
  },

  payWithPointsPayment: function (params) {
    let data = JSON.stringify(params);

    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/transactions/merchant/paywithpoints",
      {
        method: "POST",
        headers,
        body: data,
      },
    );
  },

  // getLocationData: function(params) {
  //     let data = ((params) ? Helper.jsonToUrlParameters(params) : "");
  //     return fetch(environment_configuration.payments_base_url + environment_configuration.payments_api_version + "/functions/locationdata" + data, {
  //         method:"GET",
  //         headers
  //     });
  // },

  getCouponData: function (params) {
    let data = params ? Helper.jsonToUrlParameters(params) : "";
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/promotions/coupon" +
        data,
      {
        method: "POST",
        headers,
        body: JSON.stringify(params),
      },
    );
  },

  getRenewalData: function (pmid, date) {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        `/member/renew/opportunity?pmid=${pmid}&date=${date}`,
      {
        method: "GET",
        headers,
      },
    );
  },

  getExpressRenewalData: function (hash, date) {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        `/member/renew/express?hash=${hash}&date=${date}`,
      {
        method: "GET",
        headers,
      },
    );
  },

  qbrEligible: function (params) {
    return fetch(
      environment_configuration.integration_base_url +
        environment_configuration.integration_api_version +
        "/qbr/eligible",
      {
        method: "POST",
        headers,
        body: JSON.stringify(params),
      },
    );
  },

  qbrJoin: function (params) {
    return fetch(
      environment_configuration.integration_base_url +
        environment_configuration.integration_api_version +
        "/qbr/join",
      {
        method: "POST",
        headers,
        body: JSON.stringify(params),
      },
    );
  },

  memberStatus: function (params, apiKey) {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/member/status",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify(params),
      },
    );
  },

  memberCreate: function (params) {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/member/create",
      {
        method: "POST",
        headers,
        body: JSON.stringify(params),
      },
    );
  },

  memberUpdate: function (params) {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/member/update",
      {
        method: "POST",
        headers,
        body: JSON.stringify(params),
      },
    );
  },

  getIpAddress: function (params) {
    return fetch(
      environment_configuration.payments_base_url +
        environment_configuration.payments_api_version +
        "/functions/get-ip-address",
      {
        method: "GET",
        headers,
        body: JSON.stringify(params),
      },
    )
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      });
  },

  getDatafromIP: function (ip_addr) {
    var token = "8e868512ddca9e";
    return fetch(`https://ipinfo.io/${ip_addr}?token=${token}`, {
      method: "GET",
      headers,
    });
  },

  createCheckoutSession: function (payload) {
    return fetch(
      environment_configuration.checkout_module_url + "/api/session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...payload,
          redirect: false,
          createMandate: "REQUIRED",
          autoRenew: true,
          sessionType: "new",
        }),
      },
    );
  },

  createHotelCheckoutSession: function (payload) {
    return (
      environment_configuration.checkout_module_url +
      "/api/hs-session" +
      qs.stringify(payload, { allowDots: true, addQueryPrefix: true })
    );
  },
};

export default ApiService;
